import React from 'react';

const TONES = {
  neutral: { bg: 'var(--bg-tertiary)', fg: 'var(--text-secondary)' },
  success: { bg: 'var(--success-bg)', fg: 'var(--success)' },
  accent: { bg: 'var(--accent-light)', fg: 'var(--accent-text)' },
  warning: { bg: 'var(--warning-bg)', fg: 'var(--warning)' },
  danger: { bg: 'var(--danger-bg)', fg: 'var(--danger)' },
};

export default function Pill({ children, tone = 'neutral', style }) {
  const t = TONES[tone] || TONES.neutral;
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '3px 9px',
        borderRadius: 999,
        background: t.bg,
        color: t.fg,
        fontSize: 11,
        fontWeight: 600,
        letterSpacing: '0.02em',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        ...style,
      }}
    >
      {children}
    </span>
  );
}

export function lessonStatusTone(status) {
  switch (status) {
    // Green (success) is reserved for the completed state — the actual
    // "progress" being marked. In-progress and not-started both read as
    // neutral text; the icon (see StudentCourseDetailPage's LessonRow)
    // already carries the "this is where they are" signal, so the pill
    // doesn't need to repeat it decoratively.
    case 'COMPLETED':
      return 'success';
    default:
      return 'neutral';
  }
}

export function lessonStatusLabel(status) {
  switch (status) {
    case 'COMPLETED':
      return 'Completed';
    case 'IN_PROGRESS':
      return 'In progress';
    default:
      return 'Not started';
  }
}

export function difficultyLabel(d) {
  switch (d) {
    case 'INTERMEDIATE':
      return 'Intermediate';
    case 'ADVANCED':
      return 'Advanced';
    case 'BEGINNER':
    default:
      return 'Beginner';
  }
}
